<template>
  <div>
    <v-container>
      <v-form ref="form"
              v-model="valid">
        <edit-phone-number @on-phone-updated="onPhoneUpdated"
                           :disabled="!editMode"
                           :phone="model.phone"
                           :prefix="model.prefix"
                           ref="editPhoneNumber"></edit-phone-number>
      </v-form>
    </v-container>

    <v-card-actions class="px-4 pb-3">
      <v-spacer></v-spacer>
      <v-btn v-if="!editMode"
             round
             flat
             outline
             color="primary"
             class="initialize right"
             @click="editMode = !editMode">
        {{$t('global.button.edit')}}</v-btn>

      <v-btn v-if="editMode"
             round
             flat
             color="primary"
             class="initialize right"
             :disabled="isValidatingPhoneCode"
             @click=restoreForm>
        {{$t('global.button.cancel')}}</v-btn>
      <!-- TODO: el cancelar debe hacer un reset y dejar los valores que se tenían antes -->
      <v-btn v-if="showSaveButton"
             round
             flat
             outline
             color="accent"
             class="initialize right"
             :disabled='!valid'
             :loading="isLoading"
             @click="saveForm">
        {{$t('global.button.save')}}</v-btn>

      <v-btn v-if="showVerifyButton"
             class="primary initialize right"
             :disabled='!valid'
             :loading="isLoading"
             @click="onVerifyPhoneCode">
        {{$t('global.verify')}}</v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import Advice from '@/components/commons/Advice';
import profileService from '@/services/profileService';
import store from '@/store';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';
import manageErrorService from '@/services/manageErrorService';
import sessionService from '@/services/sessionService';
import EditPhoneNumber from '@/components/commons/EditPhoneNumber';

export default {
  name: 'ChangePhone',
  components: {
    [EditPhoneNumber.name]: EditPhoneNumber,
    [Advice.name]: Advice
  },
  computed: {
    showSaveButton() {
      return this.editMode && !this.isAwaitingVerificationCode;
    },
    showVerifyButton() {
      return this.editMode && this.isAwaitingVerificationCode;
    },
    isValidatingPhoneCode() {
      return this.showVerifyButton && this.isLoading;
    }
  },
  data() {
    return {
      user: store.state.user,
      valid: false,
      editMode: false,
      isLoading: false,
      model: {
        phone: '',
        prefix: -1
      },
      isAwaitingVerificationCode: false
    };
  },

  mounted() {
    this.loadForm();
  },

  created() {
  },

  destroyed() {},

  methods: {
    onPhoneUpdated(params) {
      this.model.prefix = params.prefix;
      this.model.phone = params.phone;
    },

    loadForm() {
      this.model.phone = this.user.phone;
      this.model.prefix = Number(this.user.prefix.replace(/\s/g, '').replace('+', ''));
    },

    restoreForm() {
      this.loadForm();
      this.editMode = false;
      this.isAwaitingVerificationCode = false;
      this.isLoading = false;

      this.$refs.editPhoneNumber.reset();
    },

    async saveForm() {
      let isValidate = await this.$refs.form.validate();
      if (!isValidate) {
        return false;
      }

      let oldPhone = this.user.phone;
      let oldPrefix = Number(this.user.prefix.replace(/\s/g, '').replace('+', ''));

      if (this.model.prefix === oldPrefix && this.model.phone === oldPhone) {
        this.restoreForm();
        return;
      }

      this.isLoading = true;

      let params = {
        prefix: `+${this.model.prefix}`,
        phone: this.model.phone
      };

      let result = await profileService.checkPhone(params);

      if (result.error) {
        manageErrorService.handle(result.data);
        this.isLoading = false;
        return;
      }

      let resultSesionCheck = await sessionService.check();

      await this.$refs.editPhoneNumber.update(resultSesionCheck.data.customToken);
      this.isAwaitingVerificationCode = true;
      this.isLoading = false;
    },
    async onVerifyPhoneCode() {
      let result = this.$refs.editPhoneNumber.onVerifyPhoneCode();
      // let self = this;
      if (result) {
        this.isAwaitingVerificationCode = false;
        this.isLoading = true;
        let params = {
          phone: this.model.phone,
          prefix: '+'.concat(this.model.prefix)
        };

        let result = await profileService.updatePhone(params);

        if (result.error) {
          manageErrorService.handle(result.data);
          this.isLoading = false;
          return;
        }

        this.$refs.editPhoneNumber.reset();

        await sessionService.check(true);

        this.isLoading = false;
        this.editMode = false;

        EventBus.$emit(keys.eventOnShowNotification, {
          message: this.$i18n.t('profile.changePhone.toast.success'),
          type: 'success',
          doNotTranslate: true
        });
      }
    }
  }
};
</script>
